<template>
  <div>
    <h1>Registrar Administrador</h1>
    <b-alert v-if="success" show variant="success">Success</b-alert>
    <b-form class="mb-4" v-on:submit.prevent>
        <b-alert v-if="errorMessage" show variant="danger">{{ errorMessage }}</b-alert>
        <b-form-group label="Nombre(s)" label-for="name">
            <b-form-input  id="name" size="large" v-model="name" placeholder="Nombre(s)"></b-form-input>
            <small class="text-danger" v-if="!isLetter(name)">Campo requerido. No debe estar vacío, el campo no debe contener caracteres numéricos ni especiales</small>
        </b-form-group>
        <b-form-group label-for="lastName" label="Apellidos" >
            <b-form-input id="lastName" size="large" v-model="lastName" placeholder="Apellidos"></b-form-input>
            <small class="text-danger" v-if="!isLetter(lastName)">Campo requerido. No debe estar vacío, el campo no debe contener caracteres numéricos ni especiales</small>
        </b-form-group>
        <b-form-group label-for="email" label="Correo electrónico" :invalid-feedback="invalidEmailFeedback()" :valid-feedback="validEmailFeedback(email)">
          <b-form-input id="email" type="email" size="large" placeholder="Correo electrónico" v-model="email" trim :state="validateEmail(email)"></b-form-input>
          <small class="text-danger" v-if="!validateRegisteredEmail(email)">Este correo electrónico ya ha sido registrado previamente. Intenta con uno diferente.</small>
        </b-form-group>
        <b-form-group label-for="phone" label="Número de teléfono" :invalid-feedback="invalidPhoneFeedback()" :valid-feedback="validPhoneFeedback(phone)">
            <b-form-input id="phone" placeholder="Número de teléfono" v-model="phone" :state="validatePhoneNumber(phone)"></b-form-input>
             <small class="text-danger" v-if="!validateRegisteredPhone(phone)">Este número de teléfono ya ha sido registrado previamente. Intenta con uno diferente.</small>
             <!--{{ !validateRegisteredPhone(phone) }}-->
        </b-form-group>
        <b-form-group label-for="rol" label="Rol">
            <b-form-select id="rol" v-model="selected" :options="options"></b-form-select>
        </b-form-group>
        <!--
        <b-form-group label-for="password" label="Contraseña" :invalid-feedback="invalidvalidPasswordFeedback()" :valid-feedback="validConfirmPasswordFeedback(password)">
          <b-form-input id="password" type="password" v-model="password" :state="validatePassword(password)" trim> </b-form-input>
        </b-form-group>
        <b-form-group label-for="confirmPassword" label="Confirmar Contraseña" :invalid-feedback="invalidConfirmPasswordFeedback()" :valid-feedback="validConfirmPasswordFeedback(confirmPassword)">
          <b-form-input id="confirmPassword" type="password" v-model="confirmPassword" :state="validateConfirmPassword(confirmPassword)"></b-form-input>
        </b-form-group>-->
        <b-button
          type="primary"
          size="large"
          class="text-center w-100"
          :disabled="!validateForm()"
          @click="register"
        >
          <strong>Registrar</strong>
        </b-button>
      </b-form>
  </div>
</template>
<script>
// import { encrypt } from '@/config/headers'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const addUserMutation = gql`
  mutation addUser($email: String, $name: String, $lastName: String, $userName: String, $phoneNumber: String, $roleId: Int, $roleName: String){
      addUser(useer: { email: $email name: $name lastName: $lastName userName: $userName phoneNumber: $phoneNumber roleId: $roleId }, roleName: $roleName){
        id
        email
        name
        userName
        active
        role{
          name
        }
      }
    }
`
const USERS_QUERY = gql`
  query getUsers{
    getUsers{
      id
      email
      phoneNumber
    }
  }
`
const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 12 },
}

export default {
  name: 'RegisterAdmin',
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      name: '',
      lastName: '',
      phone: '',
      role: '',
      success: false,
      selected: null,
      options: [],
      labelCol,
      wrapperCol,
      user: {},
      errorMessage: '',
      getAllRoles: [],
      registeredUsersEmail: [],
      registeredUsersPhone: [],
    }
  },
  apollo: {
    getAllRoles: {
      query: gql`
        query getAllRoles{
          getAllRoles{
            name
            id
          }
        }
      `,
      context: headers(),
      result({ data }) {
        this.options = []
        data.getAllRoles.forEach(role => {
          this.options.push({ value: role, text: role.name })
        })
        console.log(this.options)
      },
    },
  },
  methods: {
    register() {
      this.$apollo.mutate({
        mutation: addUserMutation,
        variables: {
          email: this.email.trim(),
          user: this.user,
          name: this.name,
          lastName: this.lastName,
          userName: this.name,
          phoneNumber: '+521' + this.phone,
          roleId: parseInt(this.selected.id),
          roleName: this.selected.name,
        },
        context: headers(),
      })
        .then(data => {
          /*
          this.$cognito.signUp(this.email, this.password, this.selected.name, '+521' + this.phone)
            .then(result => {
              this.email = ''
              this.name = ''
              this.lastName = ''
              this.name = ''
              this.phone = ''
              this.selected = ''
              this.password = ''
              this.confirmPassword = ''
              this.success = true
              setTimeout(() => {
                this.success = false
              }, 3000)
            })
            .catch(error => {
              console.log(error)
            }) */
          this.$router.replace('/admin/administradores')
        })
        .catch(error => {
          console.log(error)
        })
      /*
      this.$cognito.signUp(this.email, this.password, this.selected, '+521' + this.phone)
        .then(result => {
          this.success = true
          this.$apollo.mutate({
            mutation: addUserMutation,
            variables: {
              email: this.email,
              user: this.user,
              name: this.name,
              lastName: this.lastName,
              userName: this.name,
              telefono: '+521' + this.phone,
              roleId: parseInt(this.selected),
            },
          })
            .then(data => {
              this.email = ''
              this.name = ''
              this.lastName = ''
              this.name = ''
              this.phone = ''
              this.selected = ''
              this.password = ''
              this.confirmPassword = ''
            })
            .catch(error => {
              console.log(error)
            })
          setTimeout(() => {
            this.success = false
          }, 3000)
        })
        .catch(error => {
          console.log(error)
          this.errorMessage = error.message
          setTimeout(() => {
            this.errorMessage = ''
          }, 4000)
        })
        */
    },
    isLetter(text) {
      // console.log(text)
      var re = /^[A-Za-z\u00C0-\u017F\s]+$/
      // console.log(re.test(text))
      return re.test(text)
    },
    // eslint-disable-next-line padded-blocks
    // eslint-disable-next-line space-before-blocks
    validatePassword(password){
      var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/
      return password ? re.test(password) : false
    },
    validateRegisteredEmail(email) {
      // console.log('email')
      // console.log(email)
      if (this.registeredUsersEmail[email]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredPhone(phone) {
      // console.log('phone')
      // console.log(phone)
      if (this.registeredUsersPhone['+521' + phone]) {
        return false
      } else {
        return true
      }
    },
    validPasswordFeedback(password) {
      return this.validatePassword(password) === true ? 'Válido' : ''
    },
    invalidvalidPasswordFeedback() {
      return 'La contraseña debe contener 8 caracteres;  por lo menos 1 letra mayúscula, 1 letra minúscula, 1 dígito y 1 símbolo'
    },
    validateConfirmPassword(confirmPassword) {
      return (confirmPassword === this.password) && confirmPassword !== ''
    },
    validConfirmPasswordFeedback(confirmPassword) {
      return this.validateConfirmPassword(confirmPassword) ? 'Válido' : ''
    },
    invalidConfirmPasswordFeedback() {
      return 'La contraseña no coincide'
    },
    invalidEmailFeedback() {
      return this.$t('El correo electrónico no es válido. Vuelve a intentarlo')
    },
    validEmailFeedback(email) {
      return this.validateEmail(email) === true && this.validateRegisteredEmail(email) ? 'El correo electrónico es válido' : ''
    },
    validateEmail(email) {
      var re = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
      return email ? re.test(email) : null
    },
    validatePhoneNumber(phone) {
      // eslint-disable-next-line no-useless-escape
      var re = /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/
      return phone ? re.test(phone) : null
    },
    validPhoneFeedback(phone) {
      return this.validatePhoneNumber(phone) === true && this.validateRegisteredPhone(phone) ? 'El número de teléfono es válido.' : ''
    },
    invalidPhoneFeedback() {
      return 'El número de teléfono no es válido. Vuelve a intentarlo.'
    },
    validateForm() {
      return /* this.validatePassword(this.password) && this.validateConfirmPassword(this.confirmPassword) && */ this.validatePhoneNumber(this.phone) && this.validateEmail(this.email) && this.name !== '' && this.lastName !== '' && this.selected !== null && this.validateRegisteredEmail(this.email) && this.validateRegisteredPhone(this.phone) && this.isLetter(this.name) && this.isLetter(this.lastName)
    },
    handleSubmit(e) {
      e.preventDefault()
      /*
      this.$cognito.signUp(this.email, this.password)
        .then(result => {
          console.log(result)
          this.success = true
          this.email = ''
          this.password = ''
          setTimeout(() => {
            this.success = false
          }, 3000)
        })
        .catch(error => {
          console.log(error)
        })
        */
    },
  },
  mounted() {
    this.$apollo.query({ query: USERS_QUERY, context: headers() })
      .then(({ data }) => {
        data.getUsers.forEach(user => {
          this.registeredUsersEmail[user.email] = 1
          this.registeredUsersPhone[user.phoneNumber] = 1
        })
        // console.log('Registered Users')
        // console.log(this.registeredUsersEmail)
        // console.log(this.registeredUsersPhone)
      })
      .catch(error => {
        console.log(error)
      })
  },
}
</script>
<style scoped>
</style>
